<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="model.pkId ? '编辑' : '新增'"
        width="1400px"
        class="adaptationModal"
        @close="$reset('form')">
      <el-form
          ref="form"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="90px">
        <div class="editTitle">基本信息</div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="对账类型">
              <el-select v-model="model.billType" placeholder="请选择对账类型" :disabled="model.pkId > 0">
                <el-option label="整单对账" :value="10"/>
                <el-option label="拆单对账" :value="20"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商编号">
              <el-input v-model="model.supplierNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商名称">
              <el-input v-model="model.supplierName" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="对账日期">
              <el-input :value="currentDate" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司">
              <el-input value="S100电气" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货币">
              <el-input value="CNY 中国人民币(CNY)" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="税种">
              <el-select v-model="model.taxCode" clearable placeholder="税率描述" @change="selectTaxCode(model.taxCode)">
                <el-option
                    v-for="item in constants.taxCode.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="税率">
              <el-input v-model="model.taxNumber" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="采购组">
              <el-input v-model="model.buyUserName" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建人">
              <el-input v-model="model.creatorName" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="备注">
              <el-input v-model="model.note" type="textarea" placeholder="请输入..."/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">金额信息</div>
        <el-row>
          <el-col :span="6">
            <el-form-item label="明细不含税金额" label-width="150px">
              <el-input :value="taxNotIncluded.toFixed(2)" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结算不含税金额" label-width="150px">
              <el-input :value="taxNotIncludedJS.toFixed(2)" disabled/>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="6">-->
          <!--            <el-form-item label="明细税额" label-width="150px">-->
          <!--              <el-input :value="taxSum.toFixed(2)" disabled/>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col :span="6">-->
          <!--            <el-form-item label="明细含税" label-width="150px">-->
          <!--              <el-input :value="(taxNotIncluded+taxSum).toFixed(2 )" disabled/>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="12">
            <el-form-item label="差额" label-width="150px">
              <el-input disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="实际开票不含税金额" label-width="150px">
              <el-input v-model="model.netAmount" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="实际开票税额" label-width="150px">
              <el-input v-model="model.taxAmount" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="实际开票含税金额" label-width="150px">
              <el-input v-model="model.amount" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="余额" label-width="150px">
              <el-input disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">
          对账明细
          <el-button type="primary" style="margin-bottom: 10px" @click="add()">新增</el-button>
        </div>
        <el-table stripe border :data="model.details" height="28vh">
          <el-table-column label="采购单信息" align="center">
            <el-table-column prop="poCreateTime" align="center" width="90" label="下单日期">
              <template slot-scope="scope">
                <span>{{scope.row.poCreateTime ? scope.row.poCreateTime.slice(0, 10) : ""}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="priceFlag" align="center" width="90" label="价格类型"/>
            <el-table-column prop="partNo" width="120" align="center" label="物料编号"/>
            <el-table-column prop="partNameSpec" min-width="240" show-overflow-tooltip label="物料名称"/>
            <el-table-column width="140" align="center" prop="orderNo" label="采购订单/行号">
              <!--              <template slot-scope="scope">-->
              <!--                <div>{{scope.row.evaluate + "/" + scope.row.poDetailRowNo}}</div>-->
              <!--              </template>-->
            </el-table-column>
            <el-table-column prop="poQuantity" align="center" width="100" label="采购订单数量"/>
          </el-table-column>
          <el-table-column label="送货单信息" align="center">
            <el-table-column width="140" prop="asnOrderNo" align="center" label="送货单号/行号">
              <!--              <template slot-scope="scope">-->
              <!--                <div>{{scope.row.asnNo + "/" + scope.row.asnRowIndex}}</div>-->
              <!--              </template>-->
            </el-table-column>
            <el-table-column prop="sumQuantity" align="center" width="90" label="送货单数量"/>
            <el-table-column prop="instockQuantity" align="center" width="100" label="入库数量"/>
          </el-table-column>
          <el-table-column label="对账单信息" align="center">
            <el-table-column prop="quantity" align="center" width="100" label="本次对账数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" class="inputCenter" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column
                v-if="model.pkId === 0"
                prop="leftQuantity"
                align="center"
                width="105"
                label="剩余可对账数量">
              <template slot-scope="scope">
                <span>{{scope.row.leftQuantity - scope.row.quantity}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="netPrice" align="center" width="100" label="不含税单价">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.netPrice"
                    class="inputCenter"
                    placeholder="请输入"
                    :disabled="scope.row.priceFlag !== '暂估'"/>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100" label="结算含税单价">
              <template slot-scope="scope">
                <span>{{(scope.row.netPrice * (parseInt(model.taxNumber.split("%")) / 100 + 1)).toFixed(6)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="finalPrice" width="150" label="调整差异金额(不含税)">
              <template slot-scope="scope">
                <div style="display: flex;flex-direction: row;align-items: center">
                  <span
                      v-show="parseFloat(scope.row.finalPrice) !== parseFloat((scope.row.quantity * scope.row.netPrice).toFixed(2))"
                      style="color:red">* </span>
                  <el-input v-model="scope.row.finalPrice" class="inputCenter" placeholder="请输入"/>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="110" label="结算不含税金额">
              <template slot-scope="scope">
                <span>{{(scope.row.quantity * scope.row.netPrice).toFixed(6)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100" label="结算含税金额">
              <template slot-scope="scope">
                <span>{{(scope.row.quantity * (scope.row.netPrice * (parseInt(model.taxNumber.split("%")) / 100 + 1))).toFixed(6)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="unit" align="center" width="80" label="单位"/>
            <el-table-column prop="note" align="center" width="140" label="备注">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="120px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
      </span>
    </el-dialog>
    <reconcile-order-select ref="reconcileOrderSelect" @select="reconcileOrderSelect"/>
  </div>
</template>

<script>
  import constants from "@/util/constants";
  import ReconcileOrderSelect from "@/views/purchase/ReconcileOrder/ReconcileOrderSelect";

  export default {
    components: {ReconcileOrderSelect},
    data() {
      return {
        constants,
        deleteIds: [],
        dialogVisible: false,
        submitLoading: false,
        currentDate: this.$moment().format("YYYY-MM-DD"),
        model: {
          pkId: 0,
          billType: 20,
          note: "",
          taxCode: "JD",
          taxNumber: "13%",
          supplierId: "",
          supplierNo: "",
          supplierName: "",
          buyUserName: "",
          invoice: {
            netAmount: "",
            taxAmount: "",
            amount: "",
          },
          details: [],
        },
        ruleValidate: {
          soaType: {required: true, message: "请选择对账类型", trigger: "change"},
        },
      };
    },

    computed: {
      // 明细含税金额
      // priceTwoAndThree() {
      //   let sum = 0;
      //   if(this.model.details.length> 0) {
      //     this.model.details.forEach((item) => {
      //       sum += parseFloat((item.finalPrice*1.13).toFixed(6));
      //     });
      //   }
      //   return sum;
      // },
      // //明细税额
      taxSum() {
        let sum = 0;
        if (this.model.details.length > 0) {
          this.model.details.forEach((item) => {
            sum += parseFloat((item.finalPrice * this.model.taxNumber).toFixed(2));
          });
        }
        return sum;
      },
      //明细不含税
      taxNotIncluded() {
        let sum = 0;
        if (this.model.details.length > 0) {
          this.model.details.forEach((item) => {
            sum += parseFloat(item.finalPrice);
          });
        }
        return sum;
      },
      //结算不含税金额
      taxNotIncludedJS() {
        let sum = 0;
        if (this.model.details.length > 0) {
          this.model.details.forEach((item) => {
            sum += parseFloat((item.quantity * item.netPrice).toFixed(2));
          });
        }
        return sum;
      },
    },

    methods: {
      open(mark, selection) {
        this.dialogVisible = true;
        if (!mark) {
          console.log(selection);
          selection.forEach((item) => {
            item.finalPrice = (item.quantity * item.netPrice).toFixed(2);
          });
          let arr = selection.filter(item => item.buyUserName !== selection[0].buyUserName);
          if (arr.length > 0) {
            this.$message.error("所选订单采购组不一致,无法进行对账");
            this.dialogVisible = false;
          } else {
            this.model.buyUserName = selection[0].buyUserName;
          }
          this.$nextTick(() => {
            this.model.details = selection;
            this.model.details.forEach(item => {
              item.netPrice = parseFloat(item.netPrice).toFixed(6);
              item.orderNo = item.evaluate + "/" + item.poDetailRowNo;
              item.asnOrderNo = item.asnNo + "/" + item.asnRowIndex;
            });
            this.model.supplierNo = this.model.details[0].supplierNo;
            this.model.supplierName = this.model.details[0].supplierName;
            this.model.supplierId = this.model.details[0].supplierId;
          });
        } else {
          this.getDetail(selection.pkId);
        }
      },
      selectTaxCode(taxCode) {
        if (taxCode === "JD") {
          this.model.taxNumber = "13%";
        } else if (taxCode === "JG") {
          this.model.taxNumber = "6%";
        } else if (taxCode === "K5") {
          this.model.taxNumber = "1%";
        }
        console.log(this.model.taxNumber);
      },
      // 获取对账单详情
      getDetail(id) {
        this.$http.get("basic", `soas/${id}`).then((res) => {
          console.log(res);
          if (res.success) {
            this.model = Object.assign(this.model, res.data);
            this.model.details.forEach(item => {
              item.netPrice = item.netPrice.toFixed(6);
              item.orderNo = item.evaluate + "/" + item.poDetailRowNo;
              item.asnOrderNo = item.asnNo + "/" + item.asnRowIndex;
            });
          }
        });
      },
      add() {
        if (this.model.details.length > 800) {
          this.$message.error("对账单不可超过800条");
        } else {
          this.$refs.reconcileOrderSelect.open();
        }
      },
      reconcileOrderSelect(list) {
        console.log(list);
        for (let row of list) {
          const obj = row;
          obj.netPrice = parseFloat(obj.netPrice).toFixed(6);
          obj.orderNo = obj.evaluate + "/" + obj.poDetailRowNo;
          obj.asnOrderNo = obj.asnNo + "/" + obj.asnRowIndex;
          obj.finalPrice = (obj.quantity * obj.netPrice).toFixed(2);
          this.model.details.push(obj);
        }
      },
      submitHandle() {
        if (this.model.details.length > 800) {
          this.$message.error("对账单不可超过800条");
        }
        let result = this.model.details.some((item) => (item.quantity == null || item.quantity === "") || (item.netPrice === null || item.netPrice === "") || (item.finalPrice === null || item.finalPrice === ""));
        if (result) {
          this.$confirm("本次对账数量、不含税单价、调整差异金额(不含税)不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.submitLoading = true;
        console.log(this.model);
        this.$http
          .save("basic", "soas", this.model)
          .then((res) => {
            if (res.success) {
              if (this.model.pkId) {
                this.$emit("save-success");
                this.$message.success("编辑成功");
              } else {
                this.$emit("save-success");
                this.$message.success("添加成功");
              }
              this.submitLoading = false;
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      //页面删除
      oneDelete(index, row) {
        this.model.details.splice(index, 1);
        if (row.data.pkId) {
          this.deleteIds.push(row.data.pkId);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.inputCenter .el-input__inner {
  text-align: center;
}

::v-deep .el-table .el-table__cell {
  border: 1px solid #bbb;
  border-left: none;
  border-top: none;
}

::v-deep .el-table {
  border-top: 1px solid #bbb;
}

</style>
